import { render, staticRenderFns } from "./main_prematch2.vue?vue&type=template&id=d884e178&scoped=true"
import script from "./main_prematch2.vue?vue&type=script&lang=js"
export * from "./main_prematch2.vue?vue&type=script&lang=js"
import style0 from "./main_prematch2.vue?vue&type=style&index=0&id=d884e178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d884e178",
  null
  
)

export default component.exports